import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

/**
 * CTA de reserva compartido por los drawers de "Tu selección" (simple y
 * multi-destino). Naranja de marca + WhatsApp explícito + microcopy anti-miedo:
 * para un público que no compra online, decir que NO es un pago es lo que
 * destraba el clic.
 */
interface Props {
	href: string;
	label?: string;
}

export const ReserveCta = ({ href, label = 'Reservar esta selección' }: Props): JSX.Element => (
	<Box>
		<Button
			fullWidth
			variant="contained"
			color="secondary"
			href={href}
			rel="noopener noreferrer"
			target="_blank"
			startIcon={<WhatsAppIcon />}
			sx={{
				mt: 2,
				borderRadius: '999px',
				textTransform: 'none',
				fontWeight: 900,
				fontSize: 15,
				py: 1.2,
				boxShadow: '0 8px 18px rgba(237, 102, 2, 0.22)',
			}}
		>
			{label}
		</Button>
		<Typography variant="caption" display="block" textAlign="center" color="text.secondary" mt={1}>
			Se abre WhatsApp con tu selección para enviársela a tu asesor. No es un pago.
		</Typography>
	</Box>
);

export default ReserveCta;
